import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const HelpContext = createContext(null);

export function HelpProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);

  const openHelp = useCallback(() => setIsOpen(true), []);
  const closeHelp = useCallback(() => setIsOpen(false), []);
  const toggleHelp = useCallback(() => setIsOpen((prev) => !prev), []);

  const value = useMemo(
    () => ({ isOpen, openHelp, closeHelp, toggleHelp }),
    [isOpen, openHelp, closeHelp, toggleHelp]
  );

  return <HelpContext.Provider value={value}>{children}</HelpContext.Provider>;
}

export function useHelp() {
  const ctx = useContext(HelpContext);
  if (!ctx) {
    throw new Error('useHelp must be used within a HelpProvider');
  }
  return ctx;
}

/** Safe for Header when provider might be missing in edge layouts. */
export function useHelpOptional() {
  return useContext(HelpContext);
}

export default HelpContext;
